import React from 'react';
import type { CmsImage, CmsShortText } from '$cms/types';
import { Image } from '$components/basic/Image';
import { Heading } from '$quantum/atoms/Heading';
import * as Styled from './styled';

interface ContactItemProps {
  icon: CmsImage;
  heading: CmsShortText;
  subHeading: React.ReactNode;
  extraElement?: React.ReactNode;
}
export function ContactItem({
  heading,
  icon: { alt, key, title, url },
  subHeading,
  extraElement,
}: ContactItemProps): JSX.Element {
  return (
    <Styled.ContactItemWrapper>
      <div className="contact-item">
        <div className="contact-item-image-wrapper">
          <Image
            className="contact-item-image"
            provider="cloudinary"
            src={url}
            alt={alt}
            width={64}
            height={64}
            key={key}
            title={title}
          />
        </div>
        <div className="contact-item-info">
          <Heading className="contact-item-info-heading">{heading.value}</Heading>
          {subHeading}
        </div>
      </div>
      {extraElement}
    </Styled.ContactItemWrapper>
  );
}

ContactItem.displayName = 'ContactItem';
